import {TradeService} from "../services/TradeService";
import {EquityOrder} from "../place-equity-order-wizard/models/EquityOrder";
import {EquityTicketDialogService} from "./dialog/EquityTicketDialogService";
import {PlaceOrderRequest} from "../services/models/PlaceOrderRequest";
import {extractOrderRequest} from "../place-equity-order-wizard/util/EquityWizardOrderUtil";
import {AccountId} from "../../../../account/types/AccountRecord";
import {AccountBriefRecord} from "../../../../account/types/AccountBriefRecord";
import {PortfolioType} from "../../../models/Portfolio";
import {VIRTUAL_PAGE_VIEWS} from "../../../../types/VirtualPageViews";
import {OrderViewModel} from "../../../../orders/models/OrderViewModel";
import {OrderNumber} from "../../../../orders/models/OrderRecord";
import {GTMConversionEventService} from "../../../../analytics/services/GTMConversionEventService";

export class EquityTicketService {

    public static readonly id = "equityTicketService";

    /** @ngInject */
    public constructor(private readonly tradeService: TradeService,
                       private readonly gtmConversionEventService: GTMConversionEventService,
                       private readonly equityTicketDialogService: EquityTicketDialogService) {
    }

    public async openWizard(orderPrototype: Partial<EquityOrder> = {}, accountId?: AccountId): Promise<void> {
        const data = await this.equityTicketDialogService.open(orderPrototype, accountId);
        const request = extractOrderRequest(data);
        if (request != null) {
            await this.placeOrder(request.portfolioId, request.order, data.portfolio);
        }
    }

    public async openChildOrderWizard(order: OrderViewModel, account: AccountBriefRecord): Promise<void> {
        const data = await this.equityTicketDialogService.openChildOrderWizard(order, account);
        const request = extractOrderRequest(data);
        if (request != null) {
            await this.placeOrder(request.portfolioId, request.order, data.portfolio, data.orderNumber);
        }
    }

    private async placeOrder(portfolioId: number, order: PlaceOrderRequest, portfolio: AccountBriefRecord | undefined, parentOrderNumber?: OrderNumber) {
        console.log("PLACING ORDER host:",  window.location.host);
        console.log("PLACING ORDER path:",  window.location.pathname);
        if (portfolio?.portfolioType === PortfolioType.BROKER) {
            this.gtmConversionEventService.sendVirtualPageView({
                                                                   title: VIRTUAL_PAGE_VIEWS.PlaceOrder.title,
                                                                   hostUrl: window.location.host,
                                                                   path: VIRTUAL_PAGE_VIEWS.PlaceOrder.url
                                                               });
        }
        this.gtmConversionEventService.sendPlaceOrderEvent({
                                                               title: "Place order",
                                                               hostUrl: window.location.host,
                                                               path: window.location.pathname
                                                           });
        return this.tradeService.placeTrades(portfolioId, [order], order.code, false, parentOrderNumber);
    }
}
